
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 110 110"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.378 0a53.378 53.378 0 1053.378 53.378A53.369 53.369 0 0053.378 0zm0 96.425a43.047 43.047 0 1143.047-43.047 43.035 43.035 0 01-43.047 43.047zm13.3-22.471L48.406 60.675a2.6 2.6 0 01-1.055-2.088V23.245a2.59 2.59 0 012.583-2.583h6.888a2.59 2.59 0 012.578 2.583v30.5L73.783 64.2a2.581 2.581 0 01.56 3.616L70.3 73.4a2.6 2.6 0 01-3.616.56z","fill":"#63cdf5"}})])
          )
        }
      }
    